var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModal2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 280,
    viewBox: "0 0 224 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9597_10432)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 280,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 -11H-21V302H247V-11Z",
    fill: "#79BCB0",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.998 268.195H-292.898V280.074H222.998V268.195Z",
    fill: "#D5E5FB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9597_10432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0551 34H59V281H78.0551V34Z",
    fill: "#C3DAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 34H78.0547V39.7921H303V34Z",
    fill: "#699DEE",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 151.07H78.0547V157.497H303V151.07Z",
    fill: "#699DEE",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 249.266H78.0547V256.922H303V249.266Z",
    fill: "#699DEE",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.692 151.07H247.703V105.17H191.692V151.07Z",
    fill: "#C3DAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.696 151.07H275.707V105.17H219.696V151.07Z",
    fill: "#D4E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.723 139.434H200.598L199.816 136.952L200.598 135.18H191.723V139.434Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.695 119.38H228.571L227.789 116.897L228.571 115.125H219.695V119.38Z",
    fill: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.696 115.125H210.82L211.602 117.608L210.82 119.38H219.696V115.125Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.813 151.07H175.824V105.17H119.813V151.07Z",
    fill: "#C3DAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.817 151.07H203.828V105.17H147.817V151.07Z",
    fill: "#D4E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.844 139.434H128.719L127.937 136.952L128.719 135.18H119.844V139.434Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.816 119.38H156.692L155.91 116.897L156.692 115.125H147.816V119.38Z",
    fill: "#2A4E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.817 115.125H138.941L139.723 117.608L138.941 119.38H147.817V115.125Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.829 139.922H194.953L195.735 142.405L194.953 144.177H203.829V139.922Z",
    fill: "#2A4E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.884 137.797H152.254V146.161H173.884V137.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.359 249.117H156.977V210.097H109.359V249.117Z",
    fill: "#C3DAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.167 249.117H180.785V210.097H133.167V249.117Z",
    fill: "#D4E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.387 239.222H116.932L116.27 237.109L116.932 235.602H109.387V239.222Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.168 222.175H140.713L140.047 220.062L140.713 218.555H133.168V222.175Z",
    fill: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.17 218.555H125.625L126.287 220.667L125.625 222.175H133.17V218.555Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.787 239.633H173.242L173.908 241.745L173.242 243.253H180.787V239.633Z",
    fill: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.671 212.742H163.969V218.042H177.671V212.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.559 249.117H234.297V210.001H186.559V249.117Z",
    fill: "#C3DAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.431 249.117H258.168V210.001H210.431V249.117Z",
    fill: "#D4E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59 239.197H194.155L193.489 237.081L194.155 235.57H186.59V239.197Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.43 222.103H217.994L217.329 219.991L217.994 218.477H210.43V222.103Z",
    fill: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.429 218.477H202.867L203.533 220.592L202.867 222.103H210.429V218.477Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48 105.227H158.301V70.1368H115.48V105.227Z",
    fill: "#C3DAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.89 105.227H179.711V70.1368H136.89V105.227Z",
    fill: "#D4E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.504 96.3312H122.287L121.691 94.4336L122.287 93.0781H115.504V96.3312Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.891 81.0031H143.677L143.078 79.1055L143.677 77.75H136.891V81.0031Z",
    fill: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.889 77.75H130.105L130.701 79.6476L130.105 81.0031H136.889V77.75Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.712 96.7109H172.926L173.525 98.6086L172.926 99.964H179.712V96.7109Z",
    fill: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.904 72.5234H164.582V77.2874H176.904V72.5234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.408 78.6094H203.953V105.206H236.408V78.6094Z",
    fill: "#D4E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.177 78.6094H187.723V105.206H220.177V78.6094Z",
    fill: "#C3DAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.182 86.8413H215.039L215.491 85.4032L215.039 84.375H220.182V86.8413Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18 84.375H225.323L224.87 85.8131L225.323 86.8413H220.18V84.375Z",
    fill: "#E3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.723 98.75H192.866L192.413 100.188L192.866 101.216H187.723V98.75Z",
    fill: "#9DC3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.85 84.0234H199.191V80.4133H189.85V84.0234Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9597_10432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.76 165.11H176.77L174.01 155.93H113L115.76 165.11Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.719 161.656L176.759 165.106H115.759L114.719 161.656H175.719Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.022 197.188H190.022L187.262 188.008H126.262L129.022 197.188Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.988 193.75L190.028 197.19H129.028L127.988 193.75H188.988Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19 229.258H199.19L196.43 220.078H135.43L138.19 229.258Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.148 225.812L199.188 229.262H138.188L137.148 225.812H198.148Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35 261.328H208.35L205.59 252.148H144.59L147.35 261.328Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32 257.883L208.36 261.333H147.36L146.32 257.883H207.32Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.009 274.969L156.969 101.039H162.849L214.889 274.969H209.009Z",
    fill: "#EBD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.809 101.039L210.849 274.969H209.009L156.969 101.039H158.809Z",
    fill: "#C7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.579 109.739L156.969 101.039H162.849L165.449 109.739H159.579Z",
    fill: "#C7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.171 274.969L97.1211 101.039H103.001L155.041 274.969H149.171Z",
    fill: "#EBD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9711 101.039L151.011 274.969H149.161L97.1211 101.039H98.9711Z",
    fill: "#C7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7311 109.739L97.1211 101.039H103.001L105.611 109.739H99.7311Z",
    fill: "#C7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.099 130.141H90.6289L93.8189 120.961H164.299L161.099 130.141Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8289 126.688L90.6289 130.137H161.109L162.309 126.688H91.8289Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.511 162.219H80.0312L83.2213 153.039H153.701L150.511 162.219Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2313 158.773L80.0312 162.223H150.511L151.711 158.773H81.2313Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.929 194.289H69.4492L72.6392 185.109H143.119L139.929 194.289Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6492 190.844L69.4492 194.294H139.929L141.129 190.844H70.6492Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0594 217.203L60.0694 222.933H60.0594L58.8594 226.383H129.339L130.539 222.933L132.179 218.213L132.529 217.203H62.0594ZM126.019 225.383L126.869 222.933L128.549 218.053L127.919 220.293C127.749 220.893 127.829 221.533 128.149 222.053C128.299 222.293 128.379 222.593 128.379 222.933C128.419 224.113 127.579 225.613 126.019 225.383Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.539 222.93L129.339 226.38H58.8594L60.0594 222.93H126.869L126.019 225.38C127.579 225.61 128.429 224.11 128.389 222.93H130.539Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7695 251.383C59.7295 253.363 66.4595 254.583 73.8795 254.583C83.1495 254.583 91.3495 252.683 96.3595 249.773H55.3295L54.7695 251.383Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.759 258.461H48.2891L51.4791 249.281H121.959L118.759 258.461Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4813 255.008L48.2812 258.458H118.761L119.961 255.008H49.4813Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5205 274.969L106.65 101.039H99.8605L39.7305 274.969H46.5205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.521 101.039L44.3906 274.969H46.5206L106.651 101.039H104.521Z",
    fill: "#EBD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.642 109.739L106.652 101.039H99.8616L96.8516 109.739H103.642Z",
    fill: "#EBD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.779 101.039L174.719 104.099L172.769 109.739L168.849 121.099L167.899 123.839L166.679 127.359L165.909 129.579L165.699 130.209L164.719 133.019L156.809 155.919L154.819 161.659L153.629 165.109L145.719 188.009L143.729 193.749L142.539 197.189L136.759 213.909L134.589 220.169L133.609 223.019L115.639 274.989H108.859L114.569 258.469L115.769 255.019L117.749 249.279L125.659 226.389L126.009 225.389C127.569 225.619 128.419 224.119 128.379 222.939C128.369 222.599 128.299 222.299 128.149 222.059C127.819 221.539 127.749 220.899 127.919 220.299L128.549 218.059L128.839 217.209L130.469 212.499L131.449 209.649L133.619 203.389L135.759 197.189L136.759 194.299L136.949 193.739L137.949 190.849L138.929 188.009L139.929 185.119L146.839 165.119L147.839 162.229L148.029 161.669L149.029 158.779L150.009 155.929L151.009 153.039L157.929 133.029L158.929 130.139L159.119 129.579L160.119 126.689L161.099 123.839L162.099 120.949L162.539 119.689L163.519 116.839L165.689 110.579L165.979 109.739L167.929 104.099L168.989 101.039H175.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.651 101.039L113.531 274.969H115.661L175.781 101.039H173.651Z",
    fill: "#EBD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.76 109.739L175.77 101.039H168.99L165.98 109.739H172.76Z",
    fill: "#EBD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.711 91.7812H94.2109V104.101H176.711V91.7812Z",
    fill: "#89EB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.711 100.57H94.2109V104.11H176.711V100.57Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9183 198.701L66.4583 237.291L58.9883 234.321C70.3283 206.251 74.2183 201.011 80.9683 195.161C81.9383 180.231 81.3383 145.601 81.3383 145.601C87.1783 144.641 95.6583 140.711 95.6583 140.711C99.3483 159.741 93.9183 198.701 93.9183 198.701Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9393 250.261L67.2693 252.271C65.5693 252.561 63.8093 252.121 62.4593 251.061C59.5793 248.811 56.7293 245.891 55.3293 242.001C55.1393 241.471 55.1693 240.891 55.4293 240.391L55.9193 239.431L60.7993 229.891C60.7993 229.891 64.7693 231.141 65.6793 232.621C65.6793 232.621 68.3093 229.371 70.6093 231.461C71.7193 232.471 71.3593 233.391 70.6993 234.431C70.4493 234.821 70.1593 235.241 69.8793 235.671C69.4593 236.351 69.0993 237.091 69.0193 237.941C69.0093 238.101 68.9993 238.261 69.0093 238.431C69.0093 238.491 69.0193 238.541 69.0193 238.601C69.0393 239.071 69.0493 239.511 69.0493 239.901C69.0493 240.131 69.0493 240.351 69.0493 240.551C69.0393 241.051 69.0193 241.471 68.9993 241.831C68.9893 242.081 68.9693 242.301 68.9493 242.481C68.8893 243.001 68.8393 243.231 68.8393 243.231C68.8393 243.231 75.7793 245.641 79.3993 248.401C79.4993 248.481 79.5893 248.571 79.6493 248.671C80.0193 249.271 79.6993 250.131 78.9393 250.261Z",
    fill: "#181823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6989 234.432C70.4489 234.822 70.1589 235.242 69.8789 235.672C69.1489 235.152 68.1289 234.552 68.1289 234.552C68.5589 233.902 68.6789 233.352 68.6789 233.352C69.4389 233.612 70.3389 234.112 70.6989 234.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9393 250.26L67.2693 252.27C65.5693 252.56 63.8093 252.12 62.4593 251.06C59.5793 248.81 56.7293 245.89 55.3293 242C55.1393 241.47 55.1693 240.89 55.4293 240.39L55.9193 239.43C56.8193 241.66 59.5593 247.59 64.1293 250.25C65.0793 250.8 66.1993 250.99 67.2793 250.81L79.6493 248.68C80.0193 249.27 79.6993 250.13 78.9393 250.26Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0189 237.947C69.0089 238.107 68.9989 238.267 69.0089 238.437C69.0089 238.497 69.0189 238.547 69.0189 238.607C68.3489 238.447 66.8889 238.197 65.2189 238.437L65.1289 237.807C66.8089 237.547 68.2589 237.767 69.0189 237.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0605 239.908C69.0605 240.138 69.0605 240.358 69.0605 240.558C68.3005 240.408 67.0105 240.248 65.5705 240.448L65.4805 239.818C66.9405 239.618 68.2405 239.758 69.0605 239.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0014 241.833C68.9914 242.083 68.9714 242.303 68.9514 242.483C68.1914 242.333 66.9314 242.193 65.5314 242.393L65.4414 241.763C66.8914 241.543 68.1814 241.683 69.0014 241.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.219 237.943C66.299 238.393 65.989 238.833 65.539 238.903C65.089 238.983 64.649 238.673 64.579 238.223C64.499 237.773 64.809 237.333 65.259 237.263C65.709 237.183 66.139 237.483 66.219 237.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3298 239.919C66.4098 240.379 66.0998 240.809 65.6498 240.879C65.1998 240.959 64.7598 240.649 64.6898 240.199C64.6198 239.739 64.9198 239.309 65.3698 239.239C65.8198 239.159 66.2498 239.469 66.3298 239.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5783 242.891C66.0383 242.891 66.4183 242.521 66.4183 242.051C66.4183 241.591 66.0483 241.211 65.5783 241.211C65.1183 241.211 64.7383 241.581 64.7383 242.051C64.7483 242.521 65.1183 242.891 65.5783 242.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8794 152.011C85.0094 159.421 77.1394 162.001 71.4794 160.711C66.1094 159.491 62.1794 154.781 62.1294 149.271C62.0894 145.011 64.3694 143.311 64.3694 143.311C76.1794 140.481 95.1594 137.641 95.1594 137.641C95.1594 137.641 97.8394 143.221 90.8794 152.011Z",
    fill: "#434361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.709 202.739C137.709 202.739 110.779 177.379 109.199 165.119C109.199 165.119 73.5986 169.339 64.5586 156.259L87.6586 148.289C87.6586 148.289 86.3886 149.549 114.969 153.299C120.039 153.969 141.879 197.849 141.879 197.849L137.709 202.739Z",
    fill: "#434361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.901 202.492L144.861 213.922C143.911 214.462 142.731 214.192 142.111 213.362C142.021 213.242 141.941 213.112 141.881 212.982L136.691 201.992C136.691 201.992 137.311 201.132 138.311 200.182C138.911 199.622 139.211 198.782 139.021 197.982C139.011 197.922 138.991 197.862 138.971 197.812C138.271 195.522 140.831 193.212 142.501 194.882C142.711 195.092 142.921 195.312 143.111 195.522C143.161 195.572 143.201 195.632 143.251 195.672C143.581 196.042 143.861 196.412 144.111 196.722C144.121 196.732 144.121 196.732 144.121 196.742C144.731 197.552 145.041 198.122 145.041 198.122C145.491 198.312 145.941 198.502 146.381 198.682C146.601 198.772 146.811 198.862 147.031 198.952C147.491 199.142 147.931 199.332 148.371 199.502C148.571 199.592 148.771 199.672 148.971 199.742C149.451 199.932 149.911 200.102 150.361 200.252C150.561 200.322 150.761 200.382 150.971 200.442C152.621 200.932 154.091 201.082 155.421 200.552C157.771 199.612 161.451 197.822 164.981 200.042C165.051 200.092 165.121 200.142 165.181 200.192C165.851 200.832 165.751 202.002 164.901 202.492Z",
    fill: "#181823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.902 202.491L144.852 213.921C143.902 214.461 142.722 214.191 142.102 213.361L165.162 200.211C165.852 200.831 165.752 202.001 164.902 202.491Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.012 198.952C146.972 199.422 146.742 200.112 146.002 201.032C145.872 201.192 145.732 201.352 145.582 201.522L145.102 201.102C145.252 200.932 145.392 200.772 145.512 200.622C146.352 199.552 146.412 198.952 146.362 198.672C146.592 198.762 146.802 198.852 147.012 198.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.969 200.96C146.159 201.3 146.039 201.74 145.699 201.94C145.359 202.14 144.919 202.01 144.719 201.67C144.529 201.33 144.649 200.89 144.989 200.69C145.339 200.49 145.769 200.61 145.969 200.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.952 199.748C148.852 200.168 148.602 200.718 148.072 201.398C147.922 201.588 147.762 201.788 147.572 201.998L147.102 201.568C147.272 201.378 147.432 201.188 147.562 201.018C148.102 200.328 148.302 199.838 148.352 199.508C148.552 199.598 148.752 199.678 148.952 199.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.051 201.36C148.241 201.7 148.121 202.14 147.781 202.34C147.441 202.54 147.001 202.41 146.801 202.07C146.611 201.73 146.731 201.29 147.071 201.09C147.421 200.9 147.861 201.02 148.051 201.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.949 200.461C150.839 200.871 150.589 201.401 150.089 202.051C149.939 202.241 149.779 202.441 149.579 202.661L149.109 202.231C149.289 202.041 149.439 201.851 149.569 201.681C150.049 201.061 150.259 200.601 150.329 200.281C150.549 200.331 150.749 200.401 150.949 200.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.078 202.029C150.268 202.369 150.148 202.809 149.808 203.009C149.468 203.199 149.028 203.079 148.828 202.739C148.638 202.399 148.758 201.959 149.098 201.759C149.438 201.559 149.888 201.689 150.078 202.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.099 196.738C143.179 197.248 142.369 197.857 142.369 197.857L141.809 196.848C142.249 196.338 142.769 195.958 143.249 195.688C143.579 196.067 143.859 196.418 144.099 196.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1218 124.312C19.1218 124.312 21.1318 127.253 21.2218 129.503C21.3118 131.773 19.4718 129.733 18.3918 128.283C17.5318 127.123 19.1218 124.312 19.1218 124.312Z",
    fill: "#F99C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8498 130.75C16.8498 130.75 18.7298 137.65 18.8198 140.09C18.9198 143.06 17.1698 141.55 16.2798 138.21C15.3898 134.88 16.8498 130.75 16.8498 130.75Z",
    fill: "#F99C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6816 131.32C16.6816 131.32 19.1716 136.02 19.5116 138.45C19.9216 141.39 18.0216 140.08 16.7916 136.85C15.5616 133.62 16.6816 131.32 16.6816 131.32Z",
    fill: "#F99C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5202 123.158C17.1602 122.198 14.6002 122.498 14.6002 122.498C13.5402 125.268 13.9302 132.058 15.3402 136.288C16.7402 140.528 17.2402 142.058 17.7802 140.668C18.5302 138.698 18.1502 133.848 17.9302 131.508C17.9302 131.508 19.8602 127.438 19.5202 123.158Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16 222.039C128.31 222.279 128.39 222.579 128.39 222.919C128.42 224.099 127.58 225.599 126.02 225.369L126.87 222.919L128.55 218.039L127.92 220.279C127.76 220.869 127.83 221.509 128.16 222.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9981 41.1359C76.7881 38.9759 75.5281 35.1559 74.3681 33.3859C71.5981 29.1859 65.8781 25.1659 56.1281 27.6259C44.6281 30.5259 41.4481 43.2559 45.2781 55.3859C50.5681 72.0859 50.0681 82.4259 50.0681 82.4259L78.9981 77.8259C78.9981 77.8159 79.2781 64.6159 76.9981 41.1359Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0566 60.1698C75.3866 56.8398 79.4366 47.3898 76.1066 39.0598C72.7766 30.7298 63.3266 26.6698 54.9966 29.9998C46.6666 33.3298 42.6166 42.7798 45.9466 51.1098C49.2666 59.4398 58.7266 63.4998 67.0566 60.1698Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7087 71.3503C66.3687 72.7503 64.4187 73.0703 62.6287 72.9703C60.2188 72.8503 58.0987 71.9703 58.0987 71.9703L57.8288 70.7303L56.2887 63.5103L55.9688 62.0103C56.7088 61.3003 58.1788 61.2103 59.8088 61.3203C61.4088 61.4303 63.1488 61.7503 64.4888 61.8903C65.7588 62.0203 66.6488 62.1603 66.6488 62.1603L66.9888 65.1203L67.3787 68.4603L67.7087 71.3503Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6475 62.1684L67.3775 68.4684C62.9875 68.2184 58.4375 62.9884 58.4375 62.9884L64.4875 61.8984C65.7575 62.0284 66.6475 62.1684 66.6475 62.1684Z",
    fill: "#F88968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8169 62.8331C71.7069 64.2631 69.3369 64.9331 66.9769 65.1331C64.7269 65.3231 62.4969 65.0931 60.4869 64.6931C58.9069 64.3731 57.4569 63.9431 56.2769 63.5331C55.3169 63.2031 54.5269 62.8831 53.9669 62.6331C53.3569 62.3631 53.0069 62.1931 53.0069 62.1931C53.0069 62.1931 52.4569 60.7131 51.8269 58.5131C51.1569 56.1831 50.4069 53.0431 50.1169 50.0031C49.7769 46.3731 50.1069 42.9031 52.0669 41.1631L55.8069 40.0831L73.5269 34.9531C73.5269 34.9531 73.6269 35.2131 73.7969 35.6831C74.0969 36.5031 74.6069 37.9831 75.1569 39.8431C75.1669 39.8831 75.1769 39.9231 75.1869 39.9631C75.3069 40.3731 75.4269 40.8031 75.5569 41.2531C75.6069 41.4431 75.6569 41.6331 75.7069 41.8231C77.5869 48.8331 79.1869 59.2031 73.8169 62.8331Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3083 56.9958C66.4183 57.5858 66.7783 58.0658 67.2683 58.3358C67.6083 58.5258 68.0083 58.6158 68.4283 58.5658C69.9683 58.3958 72.1083 58.2158 73.1983 58.4658C73.4883 58.5358 73.7283 58.5058 73.9283 58.4158C74.1483 58.3158 74.3183 58.1458 74.4383 57.9258C74.7183 57.4558 74.7683 56.9258 74.6283 56.4458C74.5983 56.3558 74.5583 56.2558 74.5183 56.1658C74.2983 55.6958 73.8783 55.3058 73.3383 55.1458C72.3583 54.8358 71.0083 54.4758 69.6283 54.2558C69.3183 54.2058 69.0283 54.1858 68.7483 54.1658C67.9483 54.1358 67.2483 54.4958 66.7983 55.0458C66.7383 55.1158 66.6883 55.1958 66.6383 55.2658C66.3283 55.7558 66.1883 56.3658 66.3083 56.9958Z",
    fill: "#920E08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7969 55.0393L74.5069 56.1593C74.2869 55.6893 73.8769 55.2993 73.3269 55.1393C72.3469 54.8293 70.9969 54.4693 69.6169 54.2493C69.3069 54.1993 69.0169 54.1793 68.7369 54.1593C67.9669 54.1193 67.2569 54.4793 66.7969 55.0393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2578 58.3347C67.5978 58.5247 67.9978 58.6146 68.4178 58.5646C69.9578 58.3946 72.0978 58.2146 73.1878 58.4646C73.4778 58.5346 73.7178 58.5046 73.9178 58.4146C73.5878 57.9446 72.5778 56.8246 70.4778 56.9746C68.6678 57.1046 67.6878 57.8747 67.2578 58.3347Z",
    fill: "#F85C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3395 48.1985C66.5895 49.1085 66.3895 49.9585 65.8895 50.0985C65.3895 50.2385 64.7795 49.6085 64.5295 48.6985C64.2795 47.7885 64.4795 46.9385 64.9795 46.7985C65.4695 46.6685 66.0795 47.2885 66.3395 48.1985Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2692 45.7554C75.5192 46.6654 75.3192 47.5154 74.8192 47.6554C74.3192 47.7954 73.7092 47.1654 73.4592 46.2554C73.2092 45.3454 73.4092 44.4954 73.9092 44.3554C74.4192 44.2154 75.0292 44.8454 75.2692 45.7554Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7387 51.2728C53.7387 51.2728 50.4887 48.3328 48.6087 51.0528C46.5387 54.0428 50.0587 61.3228 55.4687 59.6528L53.7387 51.2728Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0586 57.9806C54.8486 57.9906 54.6486 57.8706 54.5686 57.6706C53.0486 53.8906 50.5286 53.9606 50.5086 53.9606C50.2386 53.9706 49.9986 53.7606 49.9886 53.4906C49.9786 53.2206 50.1986 52.9806 50.4586 52.9706C50.5886 52.9606 53.7086 52.8606 55.4886 57.3006C55.5886 57.5506 55.4686 57.8506 55.2186 57.9506C55.1586 57.9706 55.1086 57.9806 55.0586 57.9806Z",
    fill: "#F88968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3197 56.3713C51.2297 56.3813 51.1497 56.3613 51.0697 56.3213C50.8197 56.2013 50.7197 55.9013 50.8397 55.6513C50.8697 55.6013 51.5197 54.3113 53.1697 54.2113C53.1797 54.2113 53.1897 54.2113 53.1997 54.2113C53.4697 54.2013 53.7097 54.4113 53.7197 54.6813C53.7297 54.9513 53.5297 55.1913 53.2497 55.2013C53.2397 55.2013 53.2297 55.2013 53.2197 55.2013C52.1397 55.2713 51.7297 56.0813 51.7197 56.0913C51.6597 56.2613 51.4997 56.3613 51.3197 56.3713Z",
    fill: "#F88968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.418 53.652C72.328 53.662 72.228 53.642 72.128 53.582C71.898 53.442 71.818 53.132 71.958 52.902L73.058 51.072L71.628 51.002C71.438 50.992 71.268 50.872 71.198 50.692L69.658 46.982C69.548 46.732 69.668 46.432 69.928 46.322C70.178 46.212 70.478 46.332 70.578 46.592L71.998 50.012L73.938 50.102C74.108 50.112 74.268 50.212 74.348 50.362C74.428 50.512 74.428 50.702 74.338 50.852L72.818 53.402C72.728 53.552 72.578 53.642 72.418 53.652Z",
    fill: "#F88968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3791 59.2393C71.9391 59.0893 72.9691 59.8093 73.0291 59.8493C73.2491 60.0093 73.2991 60.3193 73.1391 60.5493C72.9791 60.7693 72.6691 60.8193 72.4391 60.6593C72.3691 60.6093 70.9991 59.6793 69.0591 60.6693C68.8091 60.7993 68.5091 60.6993 68.3891 60.4493C68.2591 60.1993 68.3591 59.8993 68.6091 59.7793C69.2491 59.4493 69.8391 59.2893 70.3791 59.2393Z",
    fill: "#F88968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8169 35.6684C74.4469 37.9684 71.1369 41.4484 56.5769 45.9584C56.5769 45.9584 58.5869 52.6884 55.5269 52.9384C54.7969 52.9984 52.9169 49.3184 50.0769 49.9684C48.1469 46.7484 49.6769 41.7984 51.6369 40.0584L73.3769 34.1484C73.3869 34.1484 73.6569 35.1984 73.8169 35.6684Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.168 59.5809C52.168 59.5809 53.218 60.3009 55.488 59.6609C55.488 59.6609 56.038 55.3009 53.748 51.2809L56.578 45.9609C56.578 45.9609 61.548 65.4309 57.938 71.2309C57.938 71.2309 52.528 64.8609 52.168 59.5809Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3488 49.5704C61.3488 49.5704 61.0588 47.6804 62.6488 46.2304C63.8688 45.1104 64.9188 44.7104 65.5088 44.5704C65.7888 44.5004 66.0788 44.6704 66.1488 44.9504C66.2388 45.2604 66.0188 45.5804 65.6988 45.6204C64.5388 45.7904 62.0788 46.4904 61.3488 49.5704Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4794 44.214C75.1794 43.364 73.7594 43.384 72.9694 43.494C72.8794 43.504 72.7894 43.494 72.7094 43.464C72.5094 43.394 72.3594 43.194 72.3594 42.954C72.3594 42.664 72.5894 42.424 72.8794 42.424C73.4894 42.404 74.5994 42.514 76.0694 43.284C76.1494 43.324 76.2294 43.374 76.2994 43.414C76.3394 43.584 76.3694 43.764 76.4094 43.944C76.4394 44.024 76.4594 44.124 76.4794 44.214Z",
    fill: "#32324C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.538 27.592C101.538 27.592 100.978 25.332 100.318 23.682C99.6583 22.032 100.228 20.812 99.8483 19.322C99.4783 17.842 101.218 18.032 101.478 19.582C101.738 21.132 101.558 21.852 101.878 21.912C102.188 21.982 103.288 18.292 103.478 17.222C103.668 16.162 103.568 13.462 103.998 13.062C104.418 12.662 105.318 14.222 104.868 17.002C104.428 19.782 104.658 19.732 104.658 19.732C104.658 19.732 104.968 18.662 105.308 17.502C105.638 16.342 105.718 14.932 105.698 14.122C105.688 13.322 106.518 12.962 106.738 13.402C106.958 13.842 107.198 16.642 106.828 17.702C106.458 18.772 105.968 20.612 105.968 20.612C105.968 20.612 107.158 18.162 107.368 17.532C107.578 16.902 107.398 14.422 107.988 13.992C108.228 13.822 108.968 14.102 108.658 17.602C108.658 17.602 108.318 19.302 107.898 20.342C107.898 20.342 108.518 19.582 108.838 18.532C109.128 17.612 109.308 16.632 109.448 15.682C109.578 14.742 110.388 14.902 110.308 16.582C110.228 18.262 109.848 20.082 109.338 20.952C108.828 21.822 107.878 26.992 106.398 28.832L101.538 27.592Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2375 69.7388C75.2375 69.7388 72.7675 77.5987 76.1875 82.3487C76.1875 82.3487 80.6375 79.0987 85.7275 74.7787C83.9575 71.5587 82.1175 68.4688 80.4875 64.9688C78.8675 66.3887 77.1275 67.9688 75.2375 69.7388Z",
    fill: "#BC2327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.378 27.7305C101.378 27.7305 99.2577 34.3605 96.7777 42.2505C94.6577 48.9805 93.0977 53.9705 92.6777 55.3005C92.5577 55.4105 88.9177 57.7605 82.5977 63.1405C84.6877 66.0805 86.4577 69.3405 88.2677 72.5605C92.7577 68.5705 97.2477 64.0505 99.2577 60.4205C102.668 52.4305 105.958 41.7205 107.148 27.7605C105.188 27.2005 103.218 26.6805 101.378 27.7305Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4766 64.9728C82.1066 68.4728 83.9466 71.5528 85.7166 74.7828C86.5566 74.0628 87.4166 73.3228 88.2866 72.5528C86.4766 69.3428 84.7066 66.0728 82.6166 63.1328C81.9266 63.7128 81.2166 64.3228 80.4766 64.9728Z",
    fill: "#E4BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2378 87.8039C84.4778 88.6939 84.5478 89.5239 84.5078 90.3039C84.4478 91.8739 84.0078 93.1939 83.8578 94.2839C83.7978 94.7339 83.8078 95.3239 83.8678 95.9939C84.1378 98.8039 86.0378 111.924 86.0378 111.924L94.8278 137.934C78.9278 149.614 60.3778 145.104 60.3778 145.104C60.2878 129.614 59.8978 109.214 59.8978 109.214C58.4378 107.274 56.9378 104.454 55.4778 101.284C55.1378 100.534 54.7978 99.7639 54.4578 98.9939C50.1178 88.8639 46.5078 76.4939 46.5078 76.4939C49.0178 74.3039 50.4078 74.5039 53.4678 73.1339C54.3378 72.7439 55.1278 72.4139 55.8178 72.1339C57.2178 71.5639 58.1278 71.2339 58.1278 71.2339C62.4078 69.9239 67.0078 69.4939 70.3978 69.3839C70.4178 69.3839 70.4478 69.3739 70.4678 69.3739C73.4378 69.2839 75.4578 69.4239 75.4578 69.4239C75.4578 69.4239 78.4378 79.2739 82.1478 83.8839C83.2878 85.3039 83.9278 86.6139 84.2378 87.8039Z",
    fill: "#F22929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6081 78.255C62.8681 79.185 58.7481 75.805 55.8281 72.125C57.2281 71.555 58.3781 70.855 58.3781 70.855C62.6581 69.545 67.0281 69.495 70.4181 69.375C70.4381 69.375 70.4681 69.375 70.4881 69.375C71.6581 73.105 70.1681 75.765 68.7181 78.565C68.5781 78.815 67.9181 78.195 67.6081 78.255Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8586 94.2734C83.7986 94.7234 83.8086 95.3134 83.8786 95.9734C76.1786 101.673 67.0586 100.643 67.0586 100.643C78.3486 98.6034 83.8586 94.2734 83.8586 94.2734Z",
    fill: "#BC2327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.668 78.6312L71.418 76.4313L74.468 77.5113L70.688 73.2812L68.668 78.6312Z",
    fill: "#BC2327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6666 78.6434L66.0466 75.8334L64.2066 75.0834C62.3666 74.3234 60.5266 73.7034 59.2366 71.9634L58.3166 70.5234L55.2266 72.4534C55.2266 72.4534 55.3066 75.3334 56.8366 77.0234C58.3766 78.7034 62.6966 80.7634 62.6966 80.7634L65.6066 78.2534L68.6666 78.6434Z",
    fill: "#F44D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4883 69.3894L70.4783 69.3594C71.8183 71.3294 74.4683 77.5094 74.4683 77.5094L71.1683 74.4494L68.6583 78.6294C68.6683 78.6294 69.9083 74.0494 67.4883 69.3894Z",
    fill: "#F44D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6875 80.745L66.1075 75.875L68.6775 78.635L65.6475 78.535L62.6875 80.745Z",
    fill: "#BC2327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 78.2656C65.5 78.2656 66.56 80.8756 67.37 84.7256C68.16 88.4856 68.85 91.8156 68.85 91.8156",
    stroke: "#BC2327",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5067 91.0741L68.6367 78.5341L69.9967 76.4141L73.3367 90.5641L71.5067 91.0741Z",
    fill: "#E4BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9802 86.9531C84.2302 87.7331 84.5402 88.5231 84.4902 89.2631C80.4302 89.8331 76.0502 90.8031 72.1402 91.9931C69.6202 92.7731 67.6902 93.5131 66.0402 94.3331C64.7102 95.0031 63.4502 95.7731 62.1002 96.6031C59.9302 97.9331 57.7102 99.2931 55.1402 100.203C54.8102 99.5031 54.4902 98.7831 54.1602 98.0431C56.2302 97.3031 58.1402 96.1431 60.1502 94.9031C61.5102 94.0631 62.9202 93.2031 64.4302 92.4531C66.3202 91.5031 68.4902 90.6731 71.2802 89.8031C75.6402 88.4831 79.6102 87.5531 83.9802 86.9531Z",
    fill: "#E4BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0797 92.0325C69.5897 92.8025 67.6597 93.5425 66.0297 94.3625C64.7097 95.0325 63.4297 95.8025 62.0897 96.6325C59.9297 97.9525 57.7197 99.3125 55.1597 100.213C54.8297 99.5125 54.4997 98.7925 54.1797 98.0525C56.2397 97.3025 58.1597 96.1525 60.1597 94.9125C61.5197 94.0725 62.9297 93.2225 64.4397 92.4625C66.3297 91.5025 68.5097 90.6825 71.2897 89.8225L71.3097 89.8125C71.4797 90.5825 71.7497 91.3225 72.0797 92.0325Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3872 79.7299C67.6472 79.6699 67.8172 79.3999 67.7572 79.1399C67.6972 78.8799 67.4272 78.7099 67.1672 78.7699C66.9072 78.8299 66.7372 79.0999 66.7972 79.3599C66.8672 79.6199 67.1272 79.7899 67.3872 79.7299Z",
    fill: "#CC9D83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0396 82.5424C68.2996 82.4824 68.4696 82.2124 68.4096 81.9524C68.3496 81.6924 68.0796 81.5224 67.8196 81.5824C67.5596 81.6424 67.3896 81.9124 67.4496 82.1724C67.5096 82.4424 67.7796 82.6024 68.0396 82.5424Z",
    fill: "#CC9D83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7193 85.4721C68.9793 85.4121 69.1493 85.1421 69.0893 84.8821C69.0293 84.6221 68.7593 84.4521 68.4993 84.5121C68.2393 84.5721 68.0693 84.8421 68.1293 85.1021C68.1893 85.3721 68.4593 85.5321 68.7193 85.4721Z",
    fill: "#CC9D83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1797 93.3941C58.4797 92.5841 59.8297 91.8641 61.1997 91.2141C62.5897 90.5841 64.0097 89.9941 65.4997 89.6641C64.7697 89.8841 64.0597 90.1641 63.3497 90.4441C62.6397 90.7341 61.9497 91.0341 61.2597 91.3641C59.8897 92.0141 58.5497 92.7141 57.1797 93.3941Z",
    fill: "#F22929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8894 81.6226C77.7894 81.4126 78.4094 80.7626 78.2794 80.1826C78.1494 79.5926 77.2994 79.2826 76.3994 79.4826C75.4994 79.6926 74.8794 80.3426 75.0094 80.9226C75.1394 81.5226 75.9794 81.8326 76.8894 81.6226Z",
    fill: "#55B2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3096 81.0116C76.8296 80.8916 77.1896 80.5216 77.1096 80.1716C77.0296 79.8316 76.5396 79.6516 76.0296 79.7716C75.5196 79.8916 75.1496 80.2616 75.2296 80.6116C75.2996 80.9516 75.7896 81.1316 76.3096 81.0116Z",
    fill: "#C1D2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4583 91.9247C14.2683 98.5547 14.4783 122.785 14.4783 122.785C16.8683 123.785 19.5083 123.165 19.5083 123.165C19.5083 123.165 24.6983 99.3147 28.8383 95.7347C30.6283 94.1847 34.9783 92.3147 39.3283 90.6847C37.8983 87.2047 36.3883 83.7447 34.5683 80.5547C27.0583 83.8647 21.1983 87.5947 18.4583 91.9247Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5781 80.555C36.3981 83.735 37.9081 87.205 39.3381 90.685C40.6281 90.205 41.9181 89.745 43.1381 89.325C41.1981 85.915 39.0781 82.745 36.7881 79.625C36.0381 79.925 35.2981 80.235 34.5781 80.555Z",
    fill: "#E4BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6691 75.625C43.8391 76.885 40.1691 78.215 36.7891 79.605C39.0791 82.715 41.1991 85.895 43.1391 89.305C47.3491 87.845 50.7991 86.815 50.7991 86.815C50.5891 80.955 47.6691 75.625 47.6691 75.625Z",
    fill: "#F22929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9392 87.1016L55.9492 90.4316L56.9592 92.5516L63.9492 89.2216L62.9392 87.1016Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9296 87.08L62.9396 87.11L55.9496 90.44L55.9396 90.41C55.7296 89.97 55.8496 89.48 56.1996 89.31L61.9196 86.59C62.2596 86.42 62.7096 86.63 62.9296 87.08Z",
    fill: "#E4BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9375 89.2188L63.9475 89.2487C64.1575 89.6887 64.0375 90.1787 63.6875 90.3487L57.9675 93.0687C57.6175 93.2387 57.1575 93.0188 56.9475 92.5788L56.9375 92.5488L63.9375 89.2188Z",
    fill: "#E4BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8669 89.39L57.1269 92.6C57.0569 92.63 56.9769 92.61 56.9569 92.55C56.9269 92.49 56.9569 92.42 57.0269 92.38L63.7769 89.17C63.8469 89.14 63.9269 89.16 63.9469 89.22C63.9769 89.28 63.9469 89.36 63.8669 89.39Z",
    fill: "#D82727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8474 87.2282L56.1074 90.4382C56.0374 90.4682 55.9574 90.4482 55.9374 90.3882C55.9074 90.3282 55.9374 90.2582 56.0074 90.2182L62.7474 86.9982C62.8174 86.9682 62.8974 86.9882 62.9174 87.0482C62.9474 87.1082 62.9074 87.1882 62.8474 87.2282Z",
    fill: "#D82727"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.854 238.243C129.61 238.243 136.709 231.025 136.709 222.122C136.709 213.218 129.61 206 120.854 206C112.098 206 105 213.218 105 222.122C105 231.025 112.098 238.243 120.854 238.243Z",
    fill: "#D82121"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.856 233.266C126.91 233.266 131.818 228.275 131.818 222.118C131.818 215.96 126.91 210.969 120.856 210.969C114.802 210.969 109.895 215.96 109.895 222.118C109.895 228.275 114.802 233.266 120.856 233.266Z",
    fill: "#D82121"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.852 227.503C123.776 227.503 126.146 225.094 126.146 222.123C126.146 219.151 123.776 216.742 120.852 216.742C117.929 216.742 115.559 219.151 115.559 222.123C115.559 225.094 117.929 227.503 120.852 227.503Z",
    fill: "#D82121"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9597_10432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 280,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9597_10432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 247,
    fill: "white",
    transform: "translate(59 34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9597_10432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.89,
    height: 261.97,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal2);
export default __webpack_public_path__ + "static/media/modal_2.8fd133d31ce8da5ab0e2d4ff3a05a573.svg";
export { ForwardRef as ReactComponent };